const emailValidator = (str) => !str || /^[\w\.-]{1,30}(\+\d{1,3})?@[\w\.-]{1,15}(\.\w{1,10}){1,3}$/.test(str);
export default emailValidator;
